import { render, staticRenderFns } from "./ElementOverviewElementSupportTable.vue?vue&type=template&id=9536c54a&scoped=true&"
import script from "./ElementOverviewElementSupportTable.vue?vue&type=script&lang=js&"
export * from "./ElementOverviewElementSupportTable.vue?vue&type=script&lang=js&"
import style0 from "./ElementOverviewElementSupportTable.vue?vue&type=style&index=0&id=9536c54a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9536c54a",
  null
  
)

export default component.exports